import { exists } from '@/api'

export interface BatchOrderAcceptBreakingNewsConditionListItem {
  acceptanceDateFrom: string
  acceptanceDateTo: string
  branch: string
  collectionType: string
  batchType: string
}

export function BatchOrderAcceptBreakingNewsConditionListItemFromJSON(
  json: any
): BatchOrderAcceptBreakingNewsConditionListItem {
  const resp = JSON.parse(json)

  return {
    acceptanceDateFrom: exists(resp, 'acceptance_date_from')
      ? resp.acceptance_date_from
      : '',
    acceptanceDateTo: exists(resp, 'acceptance_date_to')
      ? resp.acceptance_date_to
      : '',
    branch: exists(resp, 'branch') ? resp.branch : '',
    collectionType: exists(resp, 'collection_type') ? resp.collection_type : '',
    batchType: resp.batch_type
  }
}
